import { useEffect, useRef } from 'react'

import { type LeadPayload, pushLead } from '@/lib/gtm'

const STORAGE_PREFIX = 'gtm_lead_'

/**
 * Pousse l'événement `generate_lead` GTM une seule fois par dossier.
 *
 * Même double garde que `useTrackPurchaseOnce` (ref anti-StrictMode +
 * sessionStorage par transactionId) pour éviter les doublons sur re-render ou
 * rafraîchissement de la page.
 *
 * Passer `null` tant que les données du dossier ne sont pas chargées, ou quand
 * le cas ne doit pas être tracké (paiement encaissé / SSP en attente).
 */
export function useTrackLeadOnce(payload: LeadPayload | null): void {
  const firedRef = useRef(false)

  useEffect(() => {
    if (!payload || firedRef.current) {
      return
    }

    const storageKey = `${STORAGE_PREFIX}${payload.transactionId}`
    try {
      if (sessionStorage.getItem(storageKey)) {
        return
      }
      sessionStorage.setItem(storageKey, '1')
    } catch {
      // sessionStorage indisponible (mode privé, etc.) — on retombe sur la ref seule.
    }

    firedRef.current = true
    pushLead(payload)
  }, [payload])
}
